import clsx from 'clsx';
import { ADMIN, ADMIN_DATA_CERTIFICATIONS } from 'navigator/links';
import React, { useState } from 'react';
import { BookIcon, BookOpenIcon, BriefcaseIcon, CheckMarkCircleIcon, ChevronLeftIcon, ChevronRightIcon, ParenthesisIcon } from 'resources/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { SideBarMenuOptions } from '../../types/side-bar-menu-options';
import './index.css';

type SideBarMenuItem = {
  icon: React.ReactNode | JSX.Element;
  id: SideBarMenuOptions;
};

const MenuItems: Array<SideBarMenuItem> = [
  {
    icon: (
      <div className='side-bar_menu-item-icon'>
        <BriefcaseIcon />
      </div>
    ),
    id: 'Jobs',
  },
  {
    icon: (
      <div className='side-bar_menu-item-icon'>
        <BookIcon />
      </div>
    ),
    id: 'Groups',
  },
  {
    icon: (
      <div className='side-bar_menu-item-icon'>
        <BookOpenIcon />
      </div>
    ),
    id: 'Rules',
  },
  {
    icon: (
      <div className='side-bar_menu-item-icon'>
        <ParenthesisIcon />
      </div>
    ),
    id: 'Variables',
  },
  {
    icon: (
      <div className='side-bar_menu-item-icon'>
        <CheckMarkCircleIcon />
      </div>
    ),
    id: 'Data Certifications',
  },
];

type SideBarProps = {
  selected: SideBarMenuOptions;
  setSelected: React.Dispatch<React.SetStateAction<SideBarMenuOptions>>;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  resetFilter: (value: string) => void;
};

function SideBar({ selected, setSelected, setCollapsed, resetFilter }: SideBarProps): JSX.Element {
  const [expanded, setExpanded] = useState(true);
  const navigate = useNavigate();

  function handleClick(id: SideBarMenuOptions) {
    resetFilter('');
    if (id === 'Data Certifications') {
      navigate(ADMIN_DATA_CERTIFICATIONS);
    } else {
      navigate(ADMIN);
    }
    if (id === selected) {
      setSelected(undefined);
      setCollapsed(true);
    } else {
      setSelected(id);
      setCollapsed(false);
    }
  }

  return (
    <div className='side-bar_root'>
      <div className='side-bar_expand-icon' role='button' tabIndex={0} onClick={() => setExpanded((exp) => !exp)} onKeyDown={(event) => event.key === 'Enter' && setExpanded((exp) => !exp)}>
        {expanded ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </div>
      <div className='side-bar_menu'>
        {MenuItems.map((item) => (
          <div
            className={clsx('side-bar_menu-item', {
              '--active': selected === item.id,
            })}
            key={item.id}
            onClick={() => handleClick(item.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleClick(item.id);
            }}
            role='button'
            tabIndex={0}
          >
            {item.icon}
            <div
              className={clsx('side-bar_menu-item-title', {
                '--collapsed': !expanded,
              })}
            >
              {item.id}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SideBar;
